const { SET_LANGUAGE } = require("../../store/actions.type");

const ASSETS = {
    SetDropdownState: function (condition) {
        return condition ? "enabled" : "disabled";
    },
    LanguageSelection: {
        _selector: null,
        locale: {
            "Armenian": "HY",
            "Bengali": "BN",
            "Burmese": "MY",
            "Chinese": "ZH",
            "English": "EN",
            "Farsi": "FA",
            "Gujarati": "GU",
            "Hindi": "HI",
            "Indonesian": "ID",
            "Japanese": "JA",
            "Khmer": "KM",
            "Korean": "KO",
            "Mongolian": "MN",
            "Russian": "RU",
            "Spanish": "ES",
            "Tagalog": "TL",
            "Telugu": "TE",
            "Thai": "TH",
            "Vietnamese": "VI"
        },
        List: {
            "Armenian": true,
            "Bengali": true,
            "Burmese": true,
            "Chinese": true,
            "English": true,
            "Farsi": true,
            "Gujarati": true,
            "Hindi": true,
            "Indonesian": true,
            "Japanese": true,
            "Khmer": true,
            "Korean": true,
            "Mongolian": true,
            "Russian": true,
            "Spanish": true,
            "Tagalog": true,
            "Telugu": true,
            "Thai": true,
            "Vietnamese": true
        },
        Construct: function () {
            const buttonLanguage = !ASSETS.Platform._mobile ? "button-language" : "m-button-language";
            const openEvent = !ASSETS.Platform._mobile ? "mouseover" : "click";
            this._selector = document.getElementById(buttonLanguage);
            if (this._selector != null) {
                this._selector.addEventListener(openEvent, function () {
                    ASSETS.LanguageSelection.Open();
                });
            }
        },
        Open: function () {
            const languageSelection = !ASSETS.Platform._mobile
                ? document.getElementById("language-selection")
                : document.getElementById("m-language-selection");
            const hoverSource = this._selector.getElementsByClassName("hover")[0];
            this.SwapImage(hoverSource.src);
            if (ASSETS.Platform._mobile) {
                languageSelection.style.top = "120px";
            }

            // Toggle display of language selection
            const navigationLinks = document.getElementById("primary-nav").getElementsByClassName("primary");
            const totalNavigationLinks = navigationLinks.length;
            for (let l = 0; l < totalNavigationLinks; l++) {
                navigationLinks[l].addEventListener("mouseover", function () {
                    languageSelection.style.display = "none";
                });
            }
            languageSelection.style.display = "block";
            languageSelection.addEventListener("mouseleave", function () {
                this.style.display = "none";
            });
            document.getElementById("body").addEventListener("mouseover", function () {
                languageSelection.style.display = "none";
            });

        },
        SwapImage: function (hoverSource) {
            const image = this._selector.getElementsByClassName("swap")[0];
            const originalSource = image.src;
            image.src = hoverSource;
            this._selector.addEventListener("mouseout", function () {
                image.src = originalSource;
            });
        },
        Select: async function (event, pageData, route) {
            localStorage.setItem("language", event.target.id);
            const language = ASSETS.LanguageSelection.GetCurrentLanguageAbbreviated();
            await pageData.$store.dispatch(SET_LANGUAGE, language);
            if (route.name === 'PublicStatement') {
                window.location.href = `/candidate-statements/public-statement/${route.params.contestId}/${route.params.candidateId}/${language}`;
            } else {
                window.location.reload();
            }
        },
        State: function (pageData) {
            for (let l = 0; l < Object.keys(this.List).length; l++) {
                if (Object.values(this.List)[l]) {
                    pageData.enabledLanguages.push(Object.keys(this.List)[l]);
                }
            }
        },
        GetLanguageAbbreviation: function (language) {
            switch (language) {
                case "Armenian": return 'HY';
                case "Bengali": return 'BN';
                case "Burmese": return 'MY';
                case "Chinese": return 'ZH';
                case "English": return 'EN';
                case "Farsi": return 'FA';
                case "Gujarati": return 'GU';
                case "Hindi": return 'HI';
                case "Indonesian": return 'ID';
                case "Japanese": return 'JA';
                case "Khmer": return 'KM';
                case "Korean": return 'KO';
                case "Mongolian": return 'MN';
                case "Russian": return 'RU';
                case "Spanish": return 'ES';
                case "Tagalog": return 'TL';
                case "Telugu": return 'TE';
                case "Thai": return 'TH';
                case "Vietnamese": return 'VI';
                default: return 'EN';
            }
        },
        GetCurrentLanguageAbbreviated: function () {
            const language = localStorage.getItem("language");
            return this.GetLanguageAbbreviation(language);
        }
    },
    Platform: {
        _desktop: false,
        _mobile: false,
        Construct: function () {
            this._desktop = window.getComputedStyle(document.getElementById('desktop'), null).display === 'block';
            this._mobile = window.getComputedStyle(document.getElementById('mobile'), null).display === 'block';
        }
    }
}

module.exports = { ASSETS }